import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/contact-us/hero";
import ContactForm from "../components/contact-us/contact-form";
import Footer from "../components/universal/footer";
import { Navigate } from "react-router-dom";
function Index() {
  return <Navigate to="/" />;
  // return (
  //   <div>
  //     <Helmet>
  //       <title>
  //         Same Day Smile Full Arch Implant Dentistry in Ilkley West Yorkshire
  //       </title>
  //       <link
  //         rel="canonical"
  //         href="https://www.compositebonding-ilkley.com/privacy-policy"
  //       />
  //     </Helmet>
  //     <Navbar />
  //     <Header />
  //     <ContactForm />
  //     <Footer />
  //   </div>
  // );
}

export default Index;
